import type { AnalyticsEventName, SignupContext } from '@/utils/analytics'

export function useAnalytics() {
  const { $mixpanel } = useNuxtApp()

  function track(event: AnalyticsEventName, properties?: Record<string, unknown>) {
    $mixpanel.client?.trackEvent(event, properties)
  }

  // Signup spans several page loads, so the entry point records these once and
  // Mixpanel attaches them to every later event in the flow
  function setSignupContext(context: SignupContext) {
    $mixpanel.client?.setSignupContext(context)
  }

  function resetIdentity() {
    $mixpanel.client?.resetIdentity()
  }

  return { track, setSignupContext, resetIdentity }
}
